import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import FallbackUI from ".";  // Ensure this is the correct path
import { handleErrorStack } from ".";  // Ensure this is the correct path
import PropTypes from 'prop-types';  // Optional: for prop validation

const FallBackWrap = ({ children }) => {
  return (
    <ErrorBoundary fallbackComponent={FallbackUI} onError={handleErrorStack}>
      {children}
    </ErrorBoundary>
  );
};

// Optional: Prop validation
FallBackWrap.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FallBackWrap;
